// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"c998437a","61":"0f386f5b","221":"06af2789","600":"a95691ed","719":"bb434cc5","940":"83777f3b"}[chunkId] + ".chunk.css";
};